var React = require('react');

function FlagSc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.828 423.724h494.345a8.829 8.829 0 008.828-8.828V311.908L4.85 422.664c1.209.624 2.523 1.06 3.978 1.06z","fill":"#73af00","key":0}),React.createElement("path",{"d":"M170.667 88.276H8.828A8.829 8.829 0 000 97.104v317.792c0 1.972.769 3.699 1.862 5.169L170.667 88.276z","fill":"#41479b","key":1}),React.createElement("path",{"d":"M2.613 421.158l338.72-332.881H170.667L1.862 420.065c.264.356.436.78.751 1.093z","fill":"#ffe15a","key":2}),React.createElement("path",{"d":"M503.172 88.276H341.333L2.613 421.158c.367.364.858.569 1.284.865L512 200.092V97.104a8.829 8.829 0 00-8.828-8.828z","fill":"#ff4b55","key":3}),React.createElement("path",{"d":"M4.85 422.664l507.149-110.757V200.092L3.896 422.022c.317.22.609.466.954.642z","fill":"#f5f5f5","key":4})]);
}

FlagSc.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagSc;

FlagSc.default = FlagSc;
